export default "__VITE_ASSET__Bf240DOH__"